"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var searchv2_config_1 = require("../searchv2.config");
var http_1 = require("@angular/common/http");
// using custom encoder for http params in order to have escaped + signs
var CustomEncoder = /** @class */ (function () {
    function CustomEncoder() {
    }
    CustomEncoder.prototype.encodeKey = function (key) {
        return encodeURIComponent(key);
    };
    CustomEncoder.prototype.encodeValue = function (value) {
        // same as original encoding, but not replacing %2B back to +
        return encodeURIComponent(value)
            .replace(/%40/gi, '@')
            .replace(/%3A/gi, ':')
            .replace(/%24/gi, '$')
            .replace(/%2C/gi, ',')
            .replace(/%3B/gi, ';')
            .replace(/%3D/gi, '=')
            .replace(/%3F/gi, '?')
            .replace(/%2F/gi, '/');
    };
    CustomEncoder.prototype.decodeKey = function (key) {
        return decodeURIComponent(key);
    };
    CustomEncoder.prototype.decodeValue = function (value) {
        return decodeURIComponent(value);
    };
    return CustomEncoder;
}());
var SearchAppv2Service = /** @class */ (function () {
    function SearchAppv2Service(http) {
        this.http = http;
        this.FILTER_SEPERATOR = '|';
        this.FILTER_VALUE_SEPERATOR = ':';
    }
    /**
     * Loads the initial config for ProductFinder placed by SiteCore in DOM
     */
    SearchAppv2Service.prototype.getConfig = function () {
        // use config from DOM placed as JSON in html file
        var result = searchv2_config_1.extractConfigFromDom();
        this.config = result;
        return rxjs_1.of(result);
    };
    SearchAppv2Service.prototype.getSearchResult = function (searchText, tabConfig, pageIndex, pageSize) {
        if (!tabConfig.useProductFinder) {
            return this.requestExploreAndCaseSearchResult(searchText, tabConfig.types, pageIndex, pageSize);
        }
        else {
            return this.requestProductSearchResult(searchText, pageIndex, pageSize);
        }
    };
    SearchAppv2Service.prototype.getProductScrollerSearchResult = function (searchText, pageIndex, pageSize) {
        return this.requestProductScrollerSearchResult(searchText, pageIndex, pageSize);
    };
    /**
     * to request the explore and case data from service.
     */
    SearchAppv2Service.prototype.requestExploreAndCaseSearchResult = function (searchText, types, pageIndex, pageSize) {
        var _this = this;
        var urlParams = { searchRootId: this.config.search.searchRootId };
        if (this.config.isEditMode) {
            urlParams.sc_mode = 'edit';
        }
        urlParams.q = searchText || '';
        urlParams.highlight = true;
        urlParams.pageIndex = pageIndex;
        urlParams.pageSize = pageSize;
        if (types) {
            var params_1 = [];
            types.forEach(function (type) {
                params_1.push("" + _this.config.search.typeFilterKey + _this.FILTER_VALUE_SEPERATOR + type);
            });
            urlParams.filters = params_1.join(this.FILTER_SEPERATOR);
        }
        var searchObservable = this.http
            .get(this.config.search.apiEndpoint, { params: urlParams })
            .pipe(operators_1.map(function (data) {
            return data;
        }), operators_1.catchError(function (error) {
            console.log('Error while getting data from backend', error);
            return rxjs_1.of({
                error: true,
                results: [],
                totalCount: 0,
            });
        }));
        return searchObservable;
    };
    /**
     * to request the product data from service.
     */
    SearchAppv2Service.prototype.requestProductSearchResult = function (searchText, pageIndex, pageSize) {
        var _this = this;
        if (!searchText) {
            searchText = this.FILTER_SEPERATOR;
        }
        var queryValue = searchText + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.relevanceSortCode
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.marketFilterID
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.country
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.permissionQuery;
        var urlParams = new http_1.HttpParams({ encoder: new CustomEncoder() })
            .set('query', queryValue)
            .set('lang', this.config.productFinderSearch.lang)
            .set('offset', "" + pageIndex)
            .set('pageSize', "" + pageSize);
        var searchObservable = this.http
            .get(this.config.productFinderSearch.apiEndpoint, { params: urlParams })
            .pipe(operators_1.map(function (data) {
            return _this.mapProductDataToSearchResult(data);
        }), operators_1.catchError(function (error) {
            console.log('Error while getting data from backend', error);
            return rxjs_1.of({
                error: true,
                results: [],
                totalCount: 0,
            });
        }));
        return searchObservable;
    };
    /**
     * to map the product data to search view model.
     */
    SearchAppv2Service.prototype.mapProductDataToSearchResult = function (data) {
        var _this = this;
        var oSearchResultItems = {
            error: false,
            totalCount: data.pagination ? data.pagination.totalResults : 0,
            results: []
        };
        data.results && data.results.map(function (oItem) {
            var oSearchItem = {
                type: _this.config.productFinderSearch.typeLabel,
                typeLabel: _this.config.productFinderSearch.typeLabel,
                title: {
                    modifier: null,
                    decorator: null,
                    title: oItem.name,
                    text: oItem.name,
                    href: _this.resolveProductUrl(oItem.code, oItem.brandCode),
                    target: '',
                    rel: '',
                    class: ''
                },
                tags: _this.mapTagToSearchResult(oItem),
                description: { text: oItem.description }
            };
            oSearchResultItems.results.push(oSearchItem);
        });
        return oSearchResultItems;
    };
    SearchAppv2Service.prototype.requestProductScrollerSearchResult = function (searchText, pageIndex, pageSize) {
        var _this = this;
        if (!searchText) {
            searchText = this.FILTER_SEPERATOR;
        }
        var queryValue = searchText + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.relevanceSortCode
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.marketFilterID
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.country
            + this.FILTER_VALUE_SEPERATOR + this.config.productFinderSearch.permissionQuery;
        var urlParams = new http_1.HttpParams({ encoder: new CustomEncoder() })
            .set('query', queryValue)
            .set('lang', this.config.productFinderSearch.lang)
            .set('offset', "" + pageIndex)
            .set('pageSize', "" + pageSize);
        var searchObservable = this.http
            .get(this.config.productFinderSearch.apiEndpoint, { params: urlParams })
            .pipe(operators_1.map(function (data) {
            return _this.mapProductDataToProductScrollerContent(data);
        }), operators_1.catchError(function (error) {
            console.log('Error while getting data from backend', error);
            return rxjs_1.of({
                error: true,
                results: [],
                totalCount: 0,
            });
        }));
        return searchObservable;
    };
    SearchAppv2Service.prototype.mapProductDataToProductScrollerContent = function (data) {
        var _this = this;
        var productSearchResultItems = {
            error: false,
            totalCount: data.pagination ? data.pagination.totalResults : 0,
            results: []
        };
        data.results && data.results.map(function (oItem) {
            var entry = {
                link: {
                    class: "m-scrollable-teaser__button",
                    href: _this.resolveProductUrl(oItem.code, oItem.brandCode),
                    modifier: "primary",
                    buttonlink: true,
                },
                title: {
                    modifier: "style2",
                    decorator: null,
                    text: oItem.name,
                    level: "2",
                    class: "m-scrollable-teaser__head-tlt"
                },
                description: oItem.description
            };
            productSearchResultItems.results.push(entry);
        });
        return productSearchResultItems;
    };
    /**
     * to handle the internal tags for product items.
     */
    SearchAppv2Service.prototype.mapTagToSearchResult = function (product) {
        var results = [];
        if (product != null && this.config.productFinderSearch.productTags) {
            for (var i = 0; i < this.config.productFinderSearch.productTags.length; i++) {
                var tagDefinition = this.config.productFinderSearch.productTags[i];
                var sImplementation = tagDefinition.implementation && tagDefinition.implementation.toUpperCase();
                switch (sImplementation) {
                    case "INTERNAL":
                        if (product.permission && product.permission.toUpperCase() === 'INTERNAL') {
                            results.push(tagDefinition);
                        }
                        break;
                    case "NEW":
                        if (product.productState && product.productState.toUpperCase() === 'NEW') {
                            results.push(tagDefinition);
                        }
                        break;
                    case "EOL":
                        if (product.productState && product.productState.toUpperCase() === 'EOL') {
                            results.push(tagDefinition);
                        }
                        break;
                    case "PRELIMINARY":
                        if (product.productState && product.productState.toUpperCase() === 'PRELIMINARY') {
                            results.push(tagDefinition);
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        return results;
    };
    /**
     * to map the product detail url from response items.
     */
    SearchAppv2Service.prototype.resolveProductUrl = function (code, brandCode) {
        return window.location.protocol + "//" + this.config.productFinderSearch.productRootDomain + '/' + brandCode + '/' + brandCode + '_' + code;
    };
    return SearchAppv2Service;
}());
exports.SearchAppv2Service = SearchAppv2Service;
exports.default = SearchAppv2Service;
